import type { SVGProps } from 'react';

export function CrowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.119 2.4a3.3 3.3 0 0 0-3.3 3.3v1.35L.499 17.04a1.201 1.201 0 0 0 1.44 1.92l2.88-2.16h4.924l1.747 4.241.037.083a.902.902 0 0 0 1.658-.683l-.03-.086-1.466-3.559h1.654l1.747 4.245.037.083a.902.902 0 0 0 1.658-.683l-.03-.086-1.575-3.825a7.2 7.2 0 0 0 5.239-6.93V6.9l3.018-.754a.595.595 0 0 0 .435-.727 2.4 2.4 0 0 0-2.328-1.82h-1.879a3.3 3.3 0 0 0-2.546-1.2m0 2.4c.498 0 .9.401.9.9s-.401.9-.9.9a.9.9 0 0 1-.9-.9c0-.499.401-.9.9-.9" />
    </svg>
  );
}
